import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { NEW_CHAT_PATH } from 'src/content/ChatV2/constants';

export interface UseNewChat {
  startNewChat: (event?: React.MouseEvent<HTMLElement>) => void;
}

/**
 * Opens a fresh chat. The chat surface keys a new conversation on the router
 * location, so a plain navigation is the whole reset.
 */
export const useNewChat = (): UseNewChat => {
  const navigate = useNavigate();

  const startNewChat = useCallback(
    (event?: React.MouseEvent<HTMLElement>) => {
      if (
        event &&
        (event.metaKey || event.ctrlKey || event.shiftKey || event.button === 1)
      ) {
        return;
      }
      event?.preventDefault();
      navigate(NEW_CHAT_PATH, { state: null });
    },
    [navigate]
  );

  return { startNewChat };
};
